import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { IsNewTagComponent } from '@shared/components/is-new-tag/is-new-tag.component';
import { ColorTagComponent } from '@shared/components/color-tag/color-tag.component';
import { DividerComponent } from '@shared/components/divider/divider.component';
import { IRelatedItems_Item } from '@shared/constants/models.const';
import { RouterLink } from '@angular/router';
import { OnlyDate } from '@shared/pipes/only-date';
import { RemoveHtmlPipe } from '@shared/pipes/remove-html.pipe';
import { HelperService } from '../../../../../services/helper.service';

@Component({
  selector: 'app-simple-card',
  imports: [
    IsNewTagComponent,
    ColorTagComponent,
    DividerComponent,
    RouterLink,
    OnlyDate,
    RemoveHtmlPipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: 'simple-card.component.html',
  styleUrl: 'simple-card.component.scss',
  standalone: true,
})
export class SimpleCardComponent {
  newTabLink = input(false);
  item = input.required<IRelatedItems_Item | any>();
  HELPER = inject(HelperService);

  itemLink = computed<string>(() => {
    if (this.item()) {
      return this.HELPER.getUrl(this.item().sourceUrl);
    }
    return '';
  });

  description = computed(() => {
    return this.item().summary || this.item().description;
  });

}
